import { MessageResponse } from '../../admin/models/MessageResponse';

const isMessageResponse = (data: object): data is MessageResponse => 'message' in data && 'status' in data;

export default isMessageResponse;
